import { Graphics } from 'pixi.js';
import type { AABB } from '../engine/Physics';

export type BulletOwner = 'player' | 'enemy';

export class Bullet {
  alive = true;
  gfx = new Graphics();
  private spawnX: number;
  private spawnY: number;

  constructor(
    public x: number,
    public y: number,
    public vx: number,
    public vy: number,
    public owner: BulletOwner,
    public radius = 4,
    public maxRange = 1024,
  ) {
    this.spawnX = x;
    this.spawnY = y;
    const color = owner === 'player' ? 0xfff176 : 0xff5252;
    this.gfx
      .circle(0, 0, this.radius)
      .fill({ color })
      .stroke({ color: 0x000000, width: 1 });
    this.gfx.x = x;
    this.gfx.y = y;
  }

  step(): void {
    this.x += this.vx;
    this.y += this.vy;
    const dx = this.x - this.spawnX;
    const dy = this.y - this.spawnY;
    if (Math.sqrt(dx * dx + dy * dy) > this.maxRange) {
      this.alive = false;
    }
  }

  bounds(): AABB {
    return {
      x: this.x - this.radius,
      y: this.y - this.radius,
      w: this.radius * 2,
      h: this.radius * 2,
    };
  }

  syncGfx(): void {
    this.gfx.x = this.x;
    this.gfx.y = this.y;
  }

  destroy(): void {
    this.alive = false;
    if (this.gfx.parent) this.gfx.parent.removeChild(this.gfx);
    this.gfx.destroy();
  }
}
